import DarkBgCardsFrame from "@/components/darkBgCards";
import { OFFERINGS_CONSTANTS } from "./constants";

const OfferingsComp = () => {
  return <DarkBgCardsFrame {...OFFERINGS_CONSTANTS} />;
};

export default OfferingsComp;
